import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import PageLayoutStore from '@src/business-components/page-layout/store';
import VideoListStore from './components/video-list/store';
import routeConfigs from '@src/pages/app-router/route-configs';
import { getOmniData, AuditionVideoChannelId, AuditionVideoId } from '@src/services/omni-api';
import aos from '@src/utils/aos';
import { observable } from 'mobx';
import { HIDE_DATA } from '@src/constants/urls';

class AuditionVideoStore extends BaseStore {
  @observable hideData = HIDE_DATA;

  pageLayoutStore = new PageLayoutStore({
    type: '视听中心',
    breadcrumbNavItems: [
      {
        label: '官网首页',
        path: routeConfigs.MAIN.getFormatPath({ part: 'media' })
      },
      {
        label: '视频'
      }
    ],
    isHideTopMenu: true,
    isHideStrategy: () => this.hideData
  });

  videoListStore = new VideoListStore();

  getData = async () => {
    try {
      const res = await getOmniData(AuditionVideoChannelId, [
        {
          dataSourceId: AuditionVideoId || '',
          page: 1,
          perPage: 99
        }
      ]);
      const data = res[AuditionVideoId]?.result?.items || [];
      // console.log(data);

      const videos = [];
      data.forEach((item, index) => {
        videos.push({
          id: index + 1,
          cover: item.video_poster_mo?.[0]?.url || '',
          thumb: item.video_thumbnail?.[0]?.url || '',
          video: item.video?.[0]?.url || '',
          title: item.title || '',
          titleThumbNail: item.title_thumbnail?.[0]?.url || '',
          titleThumbNailSelected: item.title_thumbnail_selected?.[0]?.url || item.title_thumbnail?.[0]?.url || ''
        });
      });
      // console.log('res', videos);

      this.videoListStore.videoList = videos;
    } catch (error) {
      console.log(error);
    }
  };
  use() {
    super.use();
    useMount(async () => {
      aos.reInit();

      this.getData();
      this.pageLayoutStore.returnBtnStore.onReturnClick = () => {
        this.redirect(routeConfigs.MAIN.getFormatPath({ part: 'media' }));
      };
      // const videoList = [
      //   {
      //     cover: require('./images/media-video-layer-10.png'),
      //     thumb: require('./images/media-video-layer-14.png'),
      //     video: 'https://static.jx3.xoyo.com/res/2017/11/01/ThirteenSects.mp4'
      //   },
      //   {
      //     cover: require('./images/media-video-layer-10.png'),
      //     thumb: require('./images/media-video-layer-16.png'),
      //     video: 'https://static.jx3.xoyo.com/res/2017/11/01/ThirteenSects.mp4'
      //   },
      //   {
      //     cover: require('./images/media-video-layer-10.png'),
      //     thumb: require('./images/media-video-layer-19.png'),
      //     video: 'https://static.jx3.xoyo.com/res/2017/11/01/ThirteenSects.mp4'
      //   }
      // ];
      // this.videoListStore.videoList = videoList;
    });
  }
}

export default AuditionVideoStore;
